module.exports = __webpack_public_path__ + "img/102.80a462be.svg";